import React from "react";
import { DiscountType } from "../Types/discount";

interface DiscountTypeSelectorProps {
  discountType: DiscountType;
  onDiscountTypeChange: (type: DiscountType) => void;
}

export const DiscountTypeSelector: React.FC<DiscountTypeSelectorProps> = ({
  discountType,
  onDiscountTypeChange,
}) => {
  const options: { value: DiscountType; label: string }[] = [
    { value: "coupon", label: "Coupon Code" },
    { value: "amount", label: "Amount" },
  ];

  return (
    <div className="flex gap-4">
      {options.map(({ value, label }) => {
        const id = `discount-${value}`;
        return (
          <label
            key={value}
            htmlFor={id}
            className={`flex items-center w-1/2 py-3 px-4 rounded-[6px] cursor-pointer border transition-colors ${
              discountType === value
                ? "border-[#165FE3]"
                : "border-[#D2D2D2] hover:border-gray-300"
            }`}
          >
            <input
              id={id}
              type="radio"
              name="discountType"
              checked={discountType === value}
              onChange={() => onDiscountTypeChange(value)}
              className="w-5 h-5 text-[#1B4ED7] border-gray-300 focus:ring-[#1B4ED7]"
            />
            <span className="ml-3 text-sm text-[#333333] font-medium leading-[16px]">
              {label}
            </span>
          </label>
        );
      })}
    </div>
  );
};
